import moment from 'moment';

export function skip(array = [], count = 0){
    if(count <= 0) return [...array];
    if(array.length <= count) return [];
    return array.slice(count);
}

export function take(array = [], count = 0) {
    if(count <= 0) return [];
    if(array.length <= count) return [...array];
    return array.slice(0, count);
}

export function page(array=[], page, pageSize) {
    return take(skip(array, (page - 1) * pageSize), pageSize);
}

export function join(left = [], right = [], leftKeyFunc, rightKeyFunc, resultFunc) {
    return left.reduce((j, l) => {
        const rst = right.filter(r => rightKeyFunc(r) === leftKeyFunc(l))
            .map(r => resultFunc(l, r));
        return j.concat(rst);
    }, []);
}

export function groupBy(source = [], keyFunc, valueFunc){
    if(typeof keyFunc === 'function') {
        const ret = source.reduce((s, k)=>{
            const key = keyFunc(k);
            if(typeof valueFunc === 'function'){
                (s[key] = s[key] || []).push(valueFunc(k));
            } else{
                (s[key] = s[key] || []).push(k);
            }
            return s;
        }, {});
        return ret;
    }
    return source;
}

//from monday to sunday
export function getCurrentWeek(base = new Date()){
    const fstWd = moment(new Date(base.setDate(base.getDate() - base.getDay() + 1)));
    return [...Array(7).keys()]
        .map(k => moment(fstWd).add(k, 'd'));
}

export function isBetween(source, b, e) {
    return source >=b && source <= e;
}

export function isPeriodCollided(source, test) {
    if (source && test) {
        const sFlag = (source.flag || 0), tFlag = (test.flag || 0);

        const t1Periods = [...Array(source.end - source.begin + 1).keys()]
            .map(k => k + source.begin);
        const t2Periods = [...Array(test.end - test.begin + 1).keys()]
            .map(k => k + test.begin);

        return source.weekday === test.weekday
            && sFlag === tFlag
            && t1Periods.some(p => t2Periods.some(p2 => p2 === p));
    }
    throw new Error('argument null');
}